const quantity = () => {
  const cart = document.querySelector('form.woocommerce-cart-form');
  if (cart) {
    const plus = cart.querySelectorAll('[data-quantity-plus]');

    if (plus) {
      plus.forEach((btn) => {
        const updateCart = document.querySelector(
          '.woocommerce .actions button[name="update_cart"]',
        );

        const amountWrapper = btn.closest('.quantity-wrapper');
        if (amountWrapper) {
          const amount = amountWrapper.querySelector('.qty');
          const btnMinus = amountWrapper.querySelector('[data-quantity-minus]');
          let val = parseFloat(amount.value);
          const max = parseFloat(amount.getAttribute('max'));
          const step = parseFloat(amount.getAttribute('step'));

          btn.addEventListener('click', () => {
            if (max && max <= val) {
              amount.value = max;
            } else {
              amount.value = val + step;
            }
            val = parseFloat(amount.value);
            if (updateCart) {
              updateCart.disabled = false;
              // eslint-disable-next-line no-undef
              jQuery("[name='update_cart']").trigger('click');
            }
          });

          btnMinus.addEventListener('click', () => {
            amount.value = val - step;
            val = parseFloat(amount.value);
            if (updateCart) {
              updateCart.disabled = false;
              // eslint-disable-next-line no-undef
              jQuery("[name='update_cart']").trigger('click');
            }
          });
        }
      });
    }
  }
};

quantity();

// eslint-disable-next-line no-undef
jQuery(document.body).on('updated_cart_totals', quantity);
